import { useEffect, useState } from "react";
import { api } from "@/AuthContext";

/**
 * Loads a catalog and returns sorted active names.
 * Usage:
 *   const authorities = useCatalog("autoridad");
 *   <select>{authorities.map(a => <option key={a.id}>{a.name}</option>)}</select>
 */
export default function useCatalog(type) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!type) return;
    let mounted = true;
    api.get("/catalogs", { params: { type } })
      .then(r => { if (mounted) setItems(r.data.filter(c => c.active !== false)); })
      .catch(() => {});
    return () => { mounted = false; };
  }, [type]);
  return items;
}
